import {
  Component,
  signal,
  ChangeDetectionStrategy,
  input,
  viewChildren,
  output
} from "@angular/core";
import { findDuplicatesByProperty } from "../../../../core-ui/services/utils";
import {
  IMetadata,
  ISelectOption,
} from "../../../../core-ui/models/interfaces";
import { MetadataBuilderPairComponent } from "./pair/pair.component";

@Component({
  selector: "av-metadata-builder",
  templateUrl: "./metadata-builder.component.html",
  styleUrls: ["./metadata-builder.component.scss"],
  standalone: false,
})
export class MetadataBuilderComponent {
  readonly meta = input<IMetadata<any>[]>(undefined);
  readonly types = input<ISelectOption[]>(undefined);

  readonly keyLabel = input("Key");
  readonly valueLabel = input("Value");

  readonly updated = output<IMetadata<any>[]>();

  readonly pairsRef = viewChildren<MetadataBuilderPairComponent>("pair");

  isDuplicateKey = signal(false);
  isFieldMissing = signal(false);

  protected itemUpdated(item: IMetadata<any>, index) {
    const duplicates = findDuplicatesByProperty(this.meta(), "key");
    this.isDuplicateKey.set(duplicates.length > 0);
    this.isFieldMissing.set(false);
    this.updated.emit(this.meta().map((m, idx) => (idx === index ? item : m)));
  }

  protected itemRemoved(item: IMetadata<any>, index) {
    this.isFieldMissing.set(false);
    this.updated.emit(this.meta().filter((m, idx) => idx !== index));
  }

  get valid() {
    let fieldsValid = true;
    this.pairsRef().forEach((item) => (fieldsValid = fieldsValid && item.valid));
    this.isFieldMissing.set(!fieldsValid);
    return !this.isDuplicateKey() && fieldsValid;
  }
}
